const Enum = require('@barchart/common-js/lang/Enum');

module.exports = (() => {
	'use strict';

	/**
	 * The status of a customer registration.
	 *
	 * @public
	 * @extends {Enum}
	 * @param {String} code
	 */
	class RegistrationStatus extends Enum {
		constructor(code) {
			super(code, code);
		}

		/**
		 * Returns the {@link RegistrationStatus} associated with a specific code.
		 *
		 * @public
		 * @static
		 * @param {String} code
		 * @returns {RegistrationStatus|null}
		 */
		static parse(code) {
			return Enum.fromCode(RegistrationStatus, code);
		}

		/**
		 * Opt-In (assumed).
		 *
		 * @public
		 * @static
		 * @returns {RegistrationStatus}
		 */
		static get OPT_IN_ASSUMED() {
			return optInAssumed;
		}

		/**
		 * Opt-In (confirmed).
		 *
		 * @public
		 * @static
		 * @returns {RegistrationStatus}
		 */
		static get OPT_IN_CONFIRMED() {
			return optInConfirmed;
		}

		/**
		 * Opt-In (pending response).
		 *
		 * @public
		 * @static
		 * @returns {RegistrationStatus}
		 */
		static get OPT_IN_PENDING() {
			return optInPending;
		}

		/**
		 * Opt-Out (confirmed).
		 *
		 * @public
		 * @static
		 * @returns {RegistrationStatus}
		 */
		static get OPT_OUT_CONFIRMED() {
			return optOutConfirmed;
		}

		toString() {
			return `[RegistrationStatus (code=${this.code})]`;
		}
	}

	const optInAssumed = new RegistrationStatus('OPT_IN_ASSUMED');
	const optInConfirmed = new RegistrationStatus('OPT_IN_CONFIRMED');
	const optInPending = new RegistrationStatus('OPT_IN_PENDING');

	const optOutConfirmed = new RegistrationStatus('OPT_OUT_CONFIRMED');

	return RegistrationStatus;
})();
